declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        iosCommunication?: {
          postMessage: (message: unknown) => void;
        };
      };
    };
  }
}

export enum iOSMessages {
  Close = 'close',
  Success = 'success',
  OrderHealthExport = 'orderHealthExport',
  InvoicesExport = 'invoicesExport',
  ARExport = 'arExport'
}

export const useIOSCommunication = () => {
  const sendMessageToIOS = (
    message: iOSMessages | string | Record<string, unknown>
  ) => {
    if (window?.webkit?.messageHandlers?.iosCommunication) {
      window.webkit.messageHandlers.iosCommunication.postMessage(message);
    } else {
      // eslint-disable-next-line no-console
      console.error('No message handler found for iOS communication');
    }
  };

  return { sendMessageToIOS };
};
